import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import mapMarkerDistanceIcon from '@iconify/icons-mdi/map-marker-distance';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import { distanceConverter } from '../../../common/utils/unitConverter';
import { useTranslation } from '../../../common/LocalizationProvider';
import { fNumber } from '../../../common/utils/formatNumber';

// utils

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.error.darker,
  backgroundColor: theme.palette.error.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.error.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.error.dark, 0)} 0%, ${alpha(
    theme.palette.error.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

AppDistance.propTypes = {
  summary: PropTypes.array,
  session: PropTypes.object
};

export default function AppDistance({ summary, session }) {
  const t = useTranslation();
  const distance = distanceConverter(
    summary.reduce((sum, item) => {
      sum += item.distance;
      return sum;
    }, 0) / 1000,
    session.uniteDistance
  );
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={mapMarkerDistanceIcon} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{`${fNumber(distance)} ${
        session.uniteDistance === 'mille' ? 'NM' : session.uniteDistance
      }`}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {t('DB_Distance')}
      </Typography>
    </RootStyle>
  );
}
